import type { PocViewFactory } from '../../../types';
import { FatalError } from '../../shared/FatalError/FatalError';

export const pocStuckViewFactory: PocViewFactory = {
  factoryName: 'pocView',
  factory: (_sm, _f, { onClose }) =>
    function PocStuckView() {
      return <FatalError onClose={onClose} />;
    },
};
